export default "__VITE_ASSET__4ea9bda7__"